import React, { useState } from 'react';

const SecurityUpgradeSection = () => {
  const [isSurveyClicked, setIsSurveyClicked] = useState(false);

  const handleSurveyClick = () => {
    setIsSurveyClicked(true);
  };

  return (
    <section className="py-16 bg-gradient-to-r from-green-800 to-green-600">
      <div className="max-w-4xl mx-auto px-4 text-center">
        <h2 className="text-4xl font-bold mb-6 text-white">Waktunya Upgrade Keamanan Anda!</h2>
        <p className="text-xl mb-8 text-green-100">
          Jangan tunggu sampai terjadi sesuatu. Lindungi properti dan orang yang Anda sayangi dengan sistem CCTV terdepan
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
          <button 
            className="bg-white text-green-600 px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-100 transition-colors"
            onClick={handleSurveyClick}
          >
            Survey Gratis Hari Ini
          </button> 
          <a href="https://wa.me/6287778882022" target="_blank" rel="noopener noreferrer">
          <button className="border-2 border-white text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-white hover:text-green-600 transition-colors">
            Konsultasi dengan Ahli
          </button>
          </a>
        </div>

        {/* Menampilkan pesan jika survey diklik */}
        {isSurveyClicked && (
          <div className="mt-4 text-xl text-yellow-200">
            Fitur ini masih dalam pengembangan
          </div>
        )}

        <div className="grid md:grid-cols-4 gap-6 text-center">
          <div>
            <div className="text-3xl font-bold text-white">5000+</div>
            <div className="text-green-200">Instalasi Sukses</div>
          </div>
          <div>
            <div className="text-3xl font-bold text-white">24/7</div>
            <div className="text-green-200">Monitoring Support</div>
          </div>
          <div>
            <div className="text-3xl font-bold text-white">99.9%</div>
            <div className="text-green-200">Uptime Guaranteed</div>
          </div>
          <div>
            <div className="text-3xl font-bold text-white">2-5 Tahun</div>
            <div className="text-green-200">Garansi Lengkap</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SecurityUpgradeSection;
